<template>
	<div class="main-content">
		<div class="center-body" >
			<Nav></Nav>
			<div class="row ph-tit">
				产品列表
			</div>
			<div class="main" style="width: 100%;height: 25px;"></div>
			<div class="row product-row" v-for="(list,index) in productList">
				<div class="item-no" style="align-items: center;" @click="toDetail(index)">
					<img :src="require(`../../assets/img/${list.src}`)" class="img-p"/>
				</div>
				<div class="col p-r">
					<div class="product-tit">
						{{list.title}}
					</div>
					<div class="product-text" v-html="list.text">
						{{list.text}}
					</div>
					<div class="product-router main-nav">
						<span style="color: #169BD5;cursor: pointer;" @click="toDetail(index)">产品详情 <Icon type="ios-arrow-forward" /></span>
					</div>
				</div>
			</div>
		</div>	
	</div>
</template>

<script>
	import Nav from './nav.vue'
	export default {
		name: 'App',
		components: {
		    Nav
		},
		data() {
			return {
				productList:[
					{
						src:'p1.jpg',
						title:'全封闭全自动吨袋破包计量风送系统',
						text:'主要应用： <br>- 应用于物料直接投加；<br>- 烟气脱硫脱硝中活性炭干式投加。'
					},
					{
						src:'p3.jpg',
						title:'全封闭全自动真空上料计量系统',
						text:'主要应用： <br>- 应用于易受潮结块及强氧化性腐蚀物料投加；<br>- 高锰酸钾等强腐蚀性物料的投加。'
					},
					{
						src:'p5.jpg',
						title:'全封闭全自动真空上料批量配药系统',
						text:'主要应用： <br>- 应用在容易受潮结块及不容易溶解彻底的物料配制及投加；<br>- PAM阴离子及阳离子等典型物料的投加。'
					},
					{
						src:'p7.jpg',
						title:'全封闭全自动吨袋批量配药系统',
						text:'主要应用： <br>- 应用于容易受潮结块及不易溶解物料的配制； <br>- 用药量较大的PAM阴离子及阳离子等典型物料的投加。'
					},
					{
						src:'p9.jpg',
						title:'全封闭全自动吨袋连续配药系统',
						text:'主要应用： <br>- 应用于吨袋物料，且物料无需溶解时间或者微溶、完全不溶，物料特性受潮结块；<br>- PAC等典型扬尘性物料的投加。'
					},
					{
						src:'p11.jpg',
						title:'全封闭全自动散装上料连续配药系统',
						text:'主要应用： <br>- 应用于散装槽车进料场合；<br>- 容易受潮结块的物料适用，如活性炭；<br>- 混有大量的渣滓等杂物的物料适用，如石灰。'
					}
				]
			}
		},
		methods: {
			toDetail(id){
				 this.$router.push({path: '/productDetail/'+id})
			},
		},
		mounted() {

		}
	}
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		display: block;
		position: absolute;
		background: #FFF;
	}
	.product-row{
		border-bottom: 1px #f5f5f5 solid;
		margin-bottom: 10px;
	}
	.product-router{
	    	display: flex;
	    	flex: 1;
	    	justify-content: flex-end;
	    	align-items: flex-end;
	    	
	    }
	@media screen and (max-width: 980px) {
	    .center-body{	    	
	    	width: 100%;
	    	
	    }
	    
	    .main-nav{
	    	display: none;
	    }
	    .img-p{
	    	width: 136px;
	    	height: 125px;
	    }
	    .ph-tit{
	    	
	    	line-height: 45px;
	    	font-size: 16px;
	    	padding-left: 10px;
	    }
	    .product-text{
	    	font-size: 12px;
	    	line-height: 1.5;
	    }
	    .p-r{
	    	margin-left:10px;
	    	padding-top:5px;
	    } 
	    .product-tit{
	    	font-size: 14px;
	    	font-weight: 600;
	    }
	   
	}
	@media screen and (min-width: 980px) {
	    .center-body{	    	
	    	width: 980px;
	    	margin: 0 auto;
	    	padding-bottom: 120px;
	    }
	    .nav-title{
	    	font-size: 30px;
	    	height: 60px;
	    	padding-top: 10px;
	    	width: 160px;
	    	text-align: center;
	    	border-bottom: 1px solid #dcdee2;
	    	flex: none;
	    	
	    }
	    .nav-right{	    	
	    	height: 60px;
	    	border-bottom: 1px solid #dcdee2;
	    	
	    }
	    .ivu-menu-item{
	    	width: 120px;
	    	text-align: center;
	    }
	    .img-p{
	    	width: 256px;
	    	height: 181px;
	    }
	    .product-row{
	    	padding: 15px;
	    }
	    .product-tit{
	    	font-size: 16px;
	    	font-weight: 600;
	    	line-height: 30px;
	    }
	    .product-text{
	    	font-size: 14px;
	    	line-height: 2;
	    }
	    .p-r{
	    	margin-left: 45px;
	    	padding-top: 15px;
	    }
	    
	    .ph-tit{
	    	display: none;
	    }
	  
	}
</style>